export default __webpack_public_path__ + "static/media/referral.bc66e9f2.png";